<template>
  <v-container fluid fill-height pa-0 ma-0 class="test_blue">
    <v-row no-gutters align-content="start" class="fill-height">
      <v-col v-if="showAlert" cols="12">
        <v-alert
          border="top"
          colored-border
          :type="alertType"
          elevation="1"
          width="100%"
        >
          <h5 v-text="alertText" />
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-card elevation="1">
          <v-card-title>
            <v-row justify="center" class="text-left">
              <v-col>
                <v-icon large style="padding-right: 10px">
                  {{ icon }}
                </v-icon>
                <small class="title">
                  <b>{{ title }}</b>
                </small>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="mb-2"></v-divider>
          <v-card-text>
            <slot />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CardTemplate",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
    alertType: {
      type: String,
      default: "info",
    },
    alertText: {
      type: String,
      default: "",
    },
  },
  computed: {
    showAlert() {
      if (this.alertText === "") {
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 1.5rem !important;
}
</style>
